import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { Config } from 'ionic-angular';

import { EventService } from '../../providers/event-service/event-service';

import { SubEventModel } from '../../app/models/subevent-model';
import { SubEventCodeModel } from '../../app/models/subeventcode-model';
import { EventCodeModel } from '../../app/models/eventcode-model';
import { EventModel } from '../../app/models/event-model';
import { QuestionnaireModel } from '../../app/models/questionnaire-model';

@Injectable()
export class RestEventService implements EventService {
  private currentEvent : EventModel;

  private serverUrl : string;

  constructor(private http: Http, configuration: Config) {
    this.currentEvent = null;
    this.serverUrl = configuration.get('backendUrl');
  }

  public getCurrentEvent() : EventModel {
    return this.currentEvent;
  }

  public isEventSelected() : boolean {
    return this.currentEvent != null;
  }

  public selectEvent(eventCode : string) : Observable<EventModel> {
    return Observable.create(observer => {
	  this.http.get(this.serverUrl+'/api/event/'+(eventCode === undefined ? "" : eventCode.trim()))
        .map(res => this.adaptFromRemoteEvent(res.json()))
        .catch(this.handleError)
        .subscribe(data => {
          this.currentEvent = data;
          observer.next(this.currentEvent);
          observer.complete();
        },
        error => {
          this.handleError(error);
          observer.next(error);
        }
      );
    });
  }

  private adaptFromRemoteEvent(event: any) : EventModel {
    //console.log("adaptFromRemoteEvent", event);
    let eventCode = new EventCodeModel(event.code);
    return new EventModel(eventCode, event.subEvents.map(s => this.adaptFromRemoteSubEvent(s, eventCode)), event.title, event.description, event.teaser, event.area, event.organizers, event.rsvpDate);
	}

  private adaptFromRemoteSubEvent(subEvent: any, eventCode: EventCodeModel) : SubEventModel {
    //console.log("adaptFromRemoteSubEvent", subEvent);
    return new SubEventModel(eventCode, new SubEventCodeModel(subEvent.code), subEvent.locationShort, subEvent.location, subEvent.title, subEvent.information, subEvent.description, subEvent.startDateTime, subEvent.endDateTime, subEvent.hasCountDown, subEvent.questionnaire.map(q => this.adaptFromRemoteQuestionnaire(q)));
	}

  private adaptFromRemoteQuestionnaire(questionnaire: any) : QuestionnaireModel {
    //console.log("adaptFromRemoteQuestionnaire", questionnaire);
    return new QuestionnaireModel(questionnaire.questionCode, questionnaire.question);
  }

  private handleError(error) {
    console.error(error);
    return Observable.throw((error.status === 404 ? error.text() : error.json().error) || 'Server error while reading event data');
  }

}



// WEBPACK FOOTER //
// ./src/providers/event-service/rest-event-service.ts